import React from 'react';
import { Link } from 'react-router-dom';
import NavBadge from '../input/NavBadge';
import './Home.css';

function SmallHomeOption({ navigate = '/', icon = 'gavel', text = '', badgeCount = 0, ...rest }) {
  const showBadge = typeof badgeCount === 'number' && badgeCount > 0;
  return (
    <Link to={navigate} className="homeQuickItem" {...rest}>
      <span className="homeQuickItemIconWrapper">
        <span className="material-symbols-rounded homeQuickItemIcon">{icon}</span>
        {showBadge && <NavBadge count={badgeCount} size={16} fontSize={10} pad={5} />}
      </span>
      <span className="homeQuickItemText">{text}</span>
      <span className="material-symbols-rounded homeQuickItemChevron">chevron_right</span>
    </Link>
  );
}

export default SmallHomeOption;
